// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

/**
 * Create a failed `Result` using the specified error.
 */
export function Err(): Failure<void>;
export function Err<TError>(error: TError): Failure<TError>;
export function Err<TError>(error?: TError): Failure<void> | Failure<TError>
{
  if (error === undefined)
  {
    return { success: false, error: undefined };
  }
  return { success: false, error: error };
}

/**
 * Create a successful `Result` using the specified value.
 */
export function Ok(): Success<void>;
export function Ok<TResult>(value: TResult): Success<TResult>;
export function Ok<TResult>(value?: TResult): Success<void> | Success<TResult>
{
  if (value === undefined)
  {
    return { success: true, value: undefined };
  }
  return { success: true, value: value };
}